import React, { ReactElement } from "react";
import { StatusCheckinEnum } from "../model/Enums/StatusCheckinEnum";
import {
    DIcon,
    IDIcon,
    ABIcon,
    CalendarCheckIcon,
    CIcon,
    CrossCircleIcon,
    AusenciaIcon,
    NegativeCircleIcon,
    WarningCircleIcon,
    CheckinIcon,
} from "./Icons";

type IconProps = {
    className?: string;
};
interface IStatusCheckinIcon extends IconProps {
    status: StatusCheckinEnum;
}

const statusIcons = new Map<StatusCheckinEnum, React.FC<IconProps>>([
    [StatusCheckinEnum.Compensado, CIcon],
    [StatusCheckinEnum.Dispensado, CheckinIcon],
    [StatusCheckinEnum.PendenciaJustificativa, CrossCircleIcon],
    [StatusCheckinEnum.AbonoAnalise, WarningCircleIcon],
    [StatusCheckinEnum.CheckinJustificado, CheckinIcon],
    [StatusCheckinEnum.CheckinRealizado, CheckinIcon],
    [StatusCheckinEnum.DesabilitadoInterjornada, NegativeCircleIcon],
    [StatusCheckinEnum.AbonoLegal, ABIcon],
    [StatusCheckinEnum.AbonoAdministrativo, ABIcon],
    [StatusCheckinEnum.Recesso, CalendarCheckIcon],
    [StatusCheckinEnum.FeriadoMunicipal, CalendarCheckIcon],
    [StatusCheckinEnum.FeriadoNacional, CalendarCheckIcon],
    [StatusCheckinEnum.Ferias, CalendarCheckIcon],
    [StatusCheckinEnum.LicencaRemunerada, CalendarCheckIcon],
    [StatusCheckinEnum.LicencaNaoRemunerada, CalendarCheckIcon],
    [StatusCheckinEnum.IndeferidoPeloCordenador, IDIcon],
    [StatusCheckinEnum.IndeferidoPelaAdministracao, IDIcon],
    [StatusCheckinEnum.DeferidoPeloCordenador, DIcon],
    [StatusCheckinEnum.DeferidoPelaAdministracao, DIcon],
    [StatusCheckinEnum.Ausencia, AusenciaIcon],
    [StatusCheckinEnum.AusenciaJustificada, AusenciaIcon],
]);

const StatusCheckinIcon: React.FC<IStatusCheckinIcon> = ({
    status,
    className = "",
}): ReactElement => {
    const Icon = statusIcons.get(status);

    if (!Icon) return <span>Ícone {status} não encontrado.</span>;

    return <Icon className={className} />;
};

export default StatusCheckinIcon;
